
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBlowerOnVertical as ObiBlowerOnVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-blower-on-vertical.js';
 
 
 

 
 export const ObiBlowerOnVertical = createComponent({
   react: React,
   tagName: 'obi-blower-on-vertical',
   elementClass: ObiBlowerOnVerticalElement,
   events: {
     
   }
  });
 
 